import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { ListSkeleton } from "@/components/common/states";
import { MailThread } from "@/components/mail/mail-thread";
import { q } from "@/data/queries";

export const Route = createFileRoute("/p/$project/mail/$threadId")({
  loader: async ({ context, params }) => {
    const thread = await context.queryClient.ensureQueryData(
      q.mailThread(params.threadId),
    );
    if (!thread) throw notFound();
    await Promise.all([
      context.queryClient.ensureQueryData(q.mailEmails(thread.id)),
      context.queryClient.ensureQueryData(q.mailDrafts(thread.accountId)),
      context.queryClient.ensureQueryData(q.account(thread.accountId)),
    ]);
    return { thread };
  },
  pendingComponent: ListSkeleton,
  component: MailThreadPage,
});

function MailThreadPage() {
  const { thread } = Route.useLoaderData();
  const { data: emails } = useSuspenseQuery(q.mailEmails(thread.id));
  const { data: allDrafts } = useSuspenseQuery(q.mailDrafts(thread.accountId));
  const { data: account } = useSuspenseQuery(q.account(thread.accountId));

  return (
    <MailThread
      thread={thread}
      emails={emails}
      drafts={allDrafts.filter((draft) => draft.threadId === thread.id)}
      account={account}
    />
  );
}
